export function splitRouteAlertDescription(description: string): string[] {
  if (!description) return [];
  return description
    .split('|')
    .map((x) => x.trim())
    .filter((x) => x.length > 0);
}
